import { Bar, BarChart, CartesianGrid, ResponsiveContainer, XAxis, YAxis } from "recharts";
import { formatDate } from "@/lib/utils";
import { CONTACTS_CHART_DATA } from "../homepage/constants";

export function NewContactsChart() {
  return (
    <div className="h-[85px]">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={CONTACTS_CHART_DATA}>
          <YAxis padding={{ top: 16 }} width={0} />
          <XAxis
            dataKey="date"
            height={0}
            tick={{
              fill: "hsl(var(--muted))",
            }}
            axisLine={{ stroke: "hsl(var(--muted))", opacity: 0.25 }}
            tickLine={{ stroke: "hsl(var(--muted))", opacity: 0.25 }}
            tickFormatter={(tickItem, index) =>
              index % 2 === 0 ? formatDate(tickItem, "MMM d") : ""
            }
            interval={0} // This will make the interval more frequent on x ticks
            fill="hsl(var(--muted))"
            fillOpacity={0.65}
            style={{ fontSize: "0.60rem" }}
            reversed
          />
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--muted))" fillOpacity={0.75} />
          <Bar
            dataKey="total"
            style={
              {
                fill: "hsl(var(--chart-accent))",
                opacity: 1,
                paddingTop: "16px",
              } as React.CSSProperties
            }
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
